import { Phases_getInstance27czzec4fvnke as Phases_getInstance } from '../request/HttpRequestPipeline.mjs';
import {
  Phases_getInstance2qxbzj50paf3c as Phases_getInstance_0,
  HttpResponseContainer3r9yzy4mwwvc9 as HttpResponseContainer,
} from '../statement/HttpResponsePipeline.mjs';
import {
  platformResponseDefaultTransformers258gm9ywvn5cc as platformResponseDefaultTransformers,
  platformRequestDefaultTransformv8a3p2llr8mo as platformRequestDefaultTransform,
} from './DefaultTransform.web.mjs';
import {
  ByteArrayContent2n0wb43y6ugs1 as ByteArrayContent,
  ReadChannelContentz1amb4hnpqp4 as ReadChannelContent,
  OutgoingContent3t2ohmyam9o76 as OutgoingContent,
} from '../../../../../ktor-ktor-http/io/ktor/http/content/OutgoingContent.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  Application_getInstance17ubdrb0i0ohu as Application_getInstance,
  Text_getInstancecnzpw4phsgym as Text_getInstance,
  Companion_getInstance3eu9tsw6r4gc4 as Companion_getInstance,
  MultiPart_getInstance1k6b6wx1k1sjr as MultiPart_getInstance,
} from '../../../../../ktor-ktor-http/io/ktor/http/ContentTypes.mjs';
import { fromInt2ii0rejb1w62w as fromInt } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  toLongkk4waq8msp1k as toLong,
  toInt2q8uldh7sc951 as toInt,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/text/numberConversions.mjs';
import {
  Unit_instance3vdlo4e4f5ggx as Unit_instance,
  Unitkvevlwgzwiuc as Unit,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  contentType2zzm38yxo3syt as contentType,
  contentLength2suzxu1lzutku as contentLength,
} from '../../../../../ktor-ktor-http/io/ktor/http/HttpMessageProperties.mjs';
import {
  ByteReadChannel2wzou76jce72d as ByteReadChannel,
  canceldn4b3cdqcfny as cancel,
} from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteReadChannel.mjs';
import {
  isInterface3d6p8outrmvmk as isInterface,
  isByteArray4nnzfn1x4o3w as isByteArray,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { TextContent1rb6ftlpvl1d2 as TextContent } from '../../../../../ktor-ktor-http/io/ktor/http/content/TextContent.mjs';
import {
  getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression,
  getKClass3t8tygqu4lcxf as getKClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  copyTo1e8cxw3cmqjst as copyTo,
  rethrowCloseCauseIfNeeded3ixo8wl4o3bz4 as rethrowCloseCauseIfNeeded,
  toByteArray1nbmiiav9igm0 as toByteArray,
  readRemaining1kbpbgdrq25q1 as readRemaining,
} from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteReadChannelOperations.mjs';
import {
  cancel2ztysw4v4hav6 as cancel_0,
  cancel36mj9lv3a0whl as cancel_1,
} from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { CIOMultipartDataBase3o5u8w437tq5s as CIOMultipartDataBase } from '../../../../../ktor-ktor-http-cio/io/ktor/http/cio/CIOMultipartDataBase.mjs';
import { MultiPartData57syw40llxls as MultiPartData } from '../../../../../ktor-ktor-http/io/ktor/http/content/Multipart.mjs';
import { HttpStatusCode3o1wkms10pg4k as HttpStatusCode } from '../../../../../ktor-ktor-http/io/ktor/http/HttpStatusCode.mjs';
import {
  get_job2zvlvce9o9a29 as get_job,
  Job13y4jkazwjho0 as Job,
} from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Job.mjs';
import {
  writer1eia5its2a1fh as writer,
  invokeOnCompletion1ziuxzoag0iwj as invokeOnCompletion,
} from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteWriteChannelOperations.mjs';
import { attachWriterJob2dr3tee7atoa9 as attachWriterJob } from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteChannelUtils.mjs';
import { checkContentLength1q7i15kkn2eie as checkContentLength } from '../call/utils.mjs';
import { PrimitiveClasses_getInstance143761yrsca9q as PrimitiveClasses_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/primitives.mjs';
import { Source1shr0ps16u4p4 as Source } from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Source.mjs';
import { readText3frapgncbqrcg as readText } from '../../../../../ktor-ktor-io/io/ktor/utils/io/Deprecation.mjs';
import { KtorSimpleLogger1xdphsp5l4e48 as KtorSimpleLogger } from '../../../../../ktor-ktor-utils/io/ktor/util/logging/KtorSimpleLogger.web.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_LOGGER() {
  _init_properties_DefaultTransform_kt__20knxx();
  return LOGGER;
}
var LOGGER;
function defaultTransformers(_this__u8e3s4) {
  _init_properties_DefaultTransform_kt__20knxx();
  var tmp = Phases_getInstance().l5m_1;
  _this__u8e3s4.g5g_1.c4t(tmp, defaultTransformers$slambda());
  var tmp_0 = Phases_getInstance_0().p5h_1;
  _this__u8e3s4.h5g_1.c4t(tmp_0, defaultTransformers$slambda_0(_this__u8e3s4));
  platformResponseDefaultTransformers(_this__u8e3s4);
}
var defaultTransformers$1$content$1Class;
function defaultTransformers$1$content$1() {
  if (defaultTransformers$1$content$1Class === VOID) {
    class $ extends ByteArrayContent() {
      constructor($contentType, $body, $box) {
        if ($box === VOID)
          $box = {};
        $box.r5o_1 = $body;
        super($box);
        var tmp = this;
        tmp.p5o_1 = $contentType == null ? Application_getInstance().i4v_1 : $contentType;
        this.q5o_1 = fromInt($body.length);
      }
      t47() {
        return this.p5o_1;
      }
      u47() {
        return this.q5o_1;
      }
      t57() {
        return this.r5o_1;
      }
    }
    initMetadataForClass($);
    defaultTransformers$1$content$1Class = $;
  }
  return defaultTransformers$1$content$1Class;
}
var defaultTransformers$1$content$2Class;
function defaultTransformers$1$content$2() {
  if (defaultTransformers$1$content$2Class === VOID) {
    class $ extends ReadChannelContent() {
      constructor($this_intercept, $contentType, $body, $box) {
        if ($box === VOID)
          $box = {};
        $box.v5o_1 = $body;
        super($box);
        var tmp = this;
        var tmp0_safe_receiver = $this_intercept.y4s_1.c5i_1.d2o('Content-Length');
        tmp.t5o_1 = tmp0_safe_receiver == null ? null : toLong(tmp0_safe_receiver);
        var tmp_0 = this;
        tmp_0.u5o_1 = $contentType == null ? Application_getInstance().i4v_1 : $contentType;
      }
      u47() {
        return this.t5o_1;
      }
      t47() {
        return this.u5o_1;
      }
      w57() {
        return this.v5o_1;
      }
    }
    initMetadataForClass($);
    defaultTransformers$1$content$2Class = $;
  }
  return defaultTransformers$1$content$2Class;
}
function defaultTransformers$slambda() {
  return constructCallableReference(function *($this$intercept, body, $completion) {
    var tmp;
    if ($this$intercept.y4s_1.c5i_1.d2o('Accept') == null) {
      $this$intercept.y4s_1.c5i_1.y4p('Accept', '*/*');
      tmp = Unit_instance;
    }
    var contentType_0 = contentType($this$intercept.y4s_1);
    var tmp_0;
    if (typeof body === 'string') {
      tmp_0 = new (TextContent())(body, contentType_0 == null ? Text_getInstance().l4w_1 : contentType_0);
    } else {
      if (isByteArray(body)) {
        tmp_0 = new (defaultTransformers$1$content$1())(contentType_0, body);
      } else {
        if (isInterface(body, ByteReadChannel())) {
          tmp_0 = new (defaultTransformers$1$content$2())($this$intercept, contentType_0, body);
        } else {
          if (body instanceof OutgoingContent()) {
            tmp_0 = body;
          } else {
            tmp_0 = platformRequestDefaultTransform(contentType_0, $this$intercept.y4s_1, body);
          }
        }
      }
    }
    var content = tmp_0;
    var tmp_1;
    if (!((content == null ? null : content.t47()) == null)) {
      $this$intercept.y4s_1.c5i_1.c4q('Content-Type');
      get_LOGGER().c4u('Transformed with default transformers request body for ' + $this$intercept.y4s_1.a5i_1.toString() + ' from ' + toString(getKClassFromExpression(body)));
      yield* $this$intercept.a4s(content, $completion);
      tmp_1 = Unit_instance;
    }
    return Unit_instance;
  }, 2);
}
function defaultTransformers$slambda$slambda($body, $response) {
  return constructCallableReference(function *($this$writer, $completion) {
    var tmp;
    try {
      yield* copyTo($body, $this$writer.l4l_1, 9223372036854775807n, $completion);
      rethrowCloseCauseIfNeeded($body);
      tmp = Unit_instance;
    } catch ($p) {
      var tmp_0;
      if ($p instanceof CancellationException()) {
        var cause = $p;
        cancel_1($response, cause);
        throw cause;
      } else {
        if ($p instanceof Error) {
          var cause_0 = $p;
          cancel_0($response, 'Receive failed', cause_0);
          throw cause_0;
        } else {
          throw $p;
        }
      }
    }
    return Unit_instance;
  }, 1);
}
function defaultTransformers$slambda_0($this_defaultTransformers) {
  return constructCallableReference(function *($this$intercept, _destruct__k2r9zo, $completion) {
    var info = _destruct__k2r9zo.ze();
    var body = _destruct__k2r9zo.af();
    if (!isInterface(body, ByteReadChannel()))
      return Unit_instance;
    var response = $this$intercept.y4s_1.t5g();
    var tmp0_subject = info.q4t_1;
    var tmp;
    if (tmp0_subject.equals(getKClass(Unit()))) {
      cancel(body);
      tmp = yield* $this$intercept.a4s(new (HttpResponseContainer())(info, Unit_instance), $completion);
    } else if (tmp0_subject.equals(PrimitiveClasses_getInstance().xf())) {
      tmp = yield* $this$intercept.a4s(new (HttpResponseContainer())(info, toInt(readText(yield* readRemaining(body, $completion)))), $completion);
    } else if (tmp0_subject.equals(getKClass(Source())) || tmp0_subject.equals(getKClass(Source()))) {
      tmp = yield* $this$intercept.a4s(new (HttpResponseContainer())(info, yield* readRemaining(body, $completion)), $completion);
    } else if (tmp0_subject.equals(PrimitiveClasses_getInstance().gg())) {
      var bytes = yield* toByteArray(body, $completion);
      checkContentLength(contentLength($this$intercept.y4s_1.t5g()), fromInt(bytes.length), $this$intercept.y4s_1.r5i().z5i());
      tmp = yield* $this$intercept.a4s(new (HttpResponseContainer())(info, bytes), $completion);
    } else if (tmp0_subject.equals(getKClass(ByteReadChannel()))) {
      var responseJobHolder = Job(get_job(response.cw()));
      // Inline function 'kotlin.also' call
      var this_0 = writer($this$intercept, $this_defaultTransformers.f5g_1, VOID, defaultTransformers$slambda$slambda(body, response));
      invokeOnCompletion(this_0, (it) => {
        responseJobHolder.u12();
        return Unit_instance;
      });
      attachWriterJob(body, this_0);
      var channel = this_0.b4l_1;
      tmp = yield* $this$intercept.a4s(new (HttpResponseContainer())(info, channel), $completion);
    } else if (tmp0_subject.equals(getKClass(HttpStatusCode()))) {
      cancel(body);
      tmp = yield* $this$intercept.a4s(new (HttpResponseContainer())(info, response.h5j()), $completion);
    } else if (tmp0_subject.equals(getKClass(MultiPartData()))) {
      var tmp0 = $this$intercept.y4s_1.t5g().y51().d2o('Content-Type');
      var tmp$ret$2;
      $l$block: {
        // Inline function 'kotlin.checkNotNull' call
        if (tmp0 == null) {
          var message = 'No content type provided for multipart';
          throw IllegalStateException().o(toString(message));
        } else {
          tmp$ret$2 = tmp0;
          break $l$block;
        }
      }
      var rawContentType = tmp$ret$2;
      var contentType = Companion_getInstance().qt(rawContentType);
      // Inline function 'kotlin.check' call
      if (!contentType.y4w(MultiPart_getInstance().e4w_1)) {
        var message_0 = 'Expected multipart/form-data, got ' + contentType.toString();
        throw IllegalStateException().o(toString(message_0));
      }
      var tmp1_safe_receiver = $this$intercept.y4s_1.t5g().y51().d2o('Content-Length');
      var contentLength_0 = tmp1_safe_receiver == null ? null : toLong(tmp1_safe_receiver);
      var body_0 = new (CIOMultipartDataBase())($this$intercept.cw(), body, rawContentType, contentLength_0);
      var parsedResponse = new (HttpResponseContainer())(info, body_0);
      tmp = yield* $this$intercept.a4s(parsedResponse, $completion);
    } else {
      tmp = null;
    }
    var result = tmp;
    var tmp_0;
    if (!(result == null)) {
      get_LOGGER().c4u('Transformed with default transformers response body ' + ('for ' + $this$intercept.y4s_1.r5i().a5j().toString() + ' to ' + toString(info.q4t_1)));
      tmp_0 = Unit_instance;
    }
    return Unit_instance;
  }, 2);
}
var properties_initialized_DefaultTransform_kt_ossax9;
function _init_properties_DefaultTransform_kt__20knxx() {
  if (!properties_initialized_DefaultTransform_kt_ossax9) {
    properties_initialized_DefaultTransform_kt_ossax9 = true;
    LOGGER = KtorSimpleLogger('io.ktor.client.plugins.defaultTransformers');
  }
}
//region block: exports
export {
  defaultTransformers as defaultTransformers2r9wd7ftt31zw,
};
//endregion

//# sourceMappingURL=DefaultTransform.mjs.map
